import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from "@angular/router"
import { Index } from 'src/app/_models';
import { Article } from 'src/app/_models/article';
import { ArticlesService } from 'src/app/_services/articles.service';
import { IndexesService } from 'src/app/_services/indexes.service';
import { NavController } from '@ionic/angular';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  @Input() type: string;
  @Input() data: Article|Index;

  public previousId: number;
  public previousRouteString: string;
  public nextId: number;
  public nextRouteString: string;

  constructor(
    private router: Router,
    private articleService: ArticlesService,
    private indexService: IndexesService,
    private location: Location,
    private navController: NavController,
  ) {

  }

  ngOnInit() {
    setTimeout(() => {
      this.fetchPrevious().then();
      this.fetchNext().then();
    }, 50);
  }

  fetchPrevious(): Promise<void> {
    return new Promise(resolve => {
      this.getPreviousRouteAndId()
        .then(previous => {
          this.previousId = previous.id;
          this.previousRouteString = previous.route;
          resolve();
        });
    });
  }

  fetchNext(): Promise<void> {
    return new Promise(resolve => {
      this.getNextRouteAndId()
        .then(next => {
          this.nextId = next.id;
          this.nextRouteString = next.route;
          resolve();
        });
    });
  }

  getPreviousRouteAndId(): Promise<any> {
    return new Promise(resolve => {
      if (this.type == 'article') {
        this.articleService.previous(this.data.id)
          .subscribe(article => {
            resolve({
              route: 'articles',
              id: article.id,
            });
          });
      } else {
        this.indexService.previous(this.data.id)
          .subscribe(index => {
            resolve({
              route: 'indexes',
              id: index.id,
            });
          });
      }
    });
  }

  getNextRouteAndId(): Promise<any> {
    return new Promise(resolve => {
      if (this.type == 'article') {
        this.articleService.next(this.data.id)
          .subscribe(article => {
            resolve({
              route: 'articles',
              id: article.id,
            });
          });
      } else {
        this.indexService.next(this.data.id)
          .subscribe(index => {
            resolve({
              route: 'indexes',
              id: index.id,
            });
          });
      }
    });
  }

  home() {
    this.navController.navigateBack('/homepage');
  }

  previousRoute() {
    if (typeof this.previousId == 'undefined') {
      this.fetchPrevious().then(() => this.previousRoute());
    } else {
      if (this.previousId != this.data.id) {
        this.navController.navigateBack('/' + this.previousRouteString + '/' + this.previousId);
      } else {
        this.goBackToIndex(this.data);
      }
    }
  }

  nextRoute() {
    if (typeof this.nextId == 'undefined') {
      this.fetchNext().then(() => this.nextRoute());
    } else {
      if (this.nextId != this.data.id) {
        this.navController.navigateForward('/' + this.nextRouteString + '/' + this.nextId);
      }
    }
  }

  goBackToIndex(data) {
    if (this.type == 'index') {
      this.navController.navigateBack('/articles/' + data.article_id);
    } else if (this.type == 'article') {
      this.navController.navigateBack('/articles');
    }
  }

}
